__turbopack_context__.v({
  "description": "UserNotLoggedForumView-module-scss-module__CIxFwG__description",
  "root": "UserNotLoggedForumView-module-scss-module__CIxFwG__root",
  "title": "UserNotLoggedForumView-module-scss-module__CIxFwG__title",
});
